























import { IWorkflowFormTemplateRevisionAccessCondition } from '@/models';
import { PropType, defineComponent } from '@vue/composition-api';
import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';

export default defineComponent({
  name: 'WorkflowFormBuilderRevisionGrantAccessDetailOptionButton',
  components: {
    DetailOptionsButton
  },
  props: {
    computation: {
      type: Object as PropType<IWorkflowFormTemplateRevisionAccessCondition>
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});
